module.exports = __webpack_public_path__ + "img/SSF Logo2.29af866e.jpg";